import { ROLES_KEYS, SupportChat, SupportChatMarker, SupportingCompanyAccessLevel } from '@interfaces';

export type SupportChatContextType = ROLES_KEYS.Foreigner | ROLES_KEYS.Employer;

export interface ContextMenuItemConfig {
  labelKey: string;
  icon: string;
  actionKey: string;
  requiredSupportingCompanyAccessLevel: SupportingCompanyAccessLevel | null;
  iconCustomClass?: string;
  permissionKey?: string;
  routerLink?: any[];
  queryParams?: Record<string, any>;
  disabledFn?: (supportChat: SupportChat) => boolean;

  supportedTypes?: SupportChatContextType[];
}

export const SUPPORT_CHAT_CONTEXT_MENU_ITEMS: ContextMenuItemConfig[] = [
  {
    supportedTypes: [ROLES_KEYS.Foreigner, ROLES_KEYS.Employer],
    labelKey: 'CHAT.MARK_ATTENTION_REQUIRED',
    icon: 'priority_high',
    iconCustomClass: 'icon-attention',
    actionKey: 'markAttention',
    requiredSupportingCompanyAccessLevel: SupportingCompanyAccessLevel.canEditProcesses,
    disabledFn: supportChat => {
      return supportChat.marker === SupportChatMarker.ATTENTION_REQUIRED;
    },
  },
  {
    supportedTypes: [ROLES_KEYS.Foreigner, ROLES_KEYS.Employer],
    labelKey: 'CHAT.MARK_AS_COMEBACK_LATER',
    icon: 'schedule',
    iconCustomClass: 'icon-later',
    actionKey: 'markLater',
    requiredSupportingCompanyAccessLevel: SupportingCompanyAccessLevel.canEditProcesses,
    disabledFn: supportChat => {
      return supportChat.marker === SupportChatMarker.COMEBACK_LATER;
    },
  },
  {
    supportedTypes: [ROLES_KEYS.Foreigner, ROLES_KEYS.Employer],
    labelKey: 'CHAT.DELETE_MARK',
    icon: 'close',
    iconCustomClass: 'icon-remove',
    actionKey: 'removeMarker',
    requiredSupportingCompanyAccessLevel: SupportingCompanyAccessLevel.canEditProcesses,
    disabledFn: supportChat => {
      return !supportChat.marker;
    },
  },
  {
    supportedTypes: [ROLES_KEYS.Foreigner, ROLES_KEYS.Employer],
    labelKey: 'CHAT.MARK_AS_UNREAD',
    icon: 'visibility_off',
    actionKey: 'markAsUnread',
    requiredSupportingCompanyAccessLevel: null,
    disabledFn: supportChat => {
      return !supportChat.readByEmployeeAt;
    },
  },
  {
    supportedTypes: [ROLES_KEYS.Foreigner],
    labelKey: 'MANAGEMENT.FOLLOW_UP.FOLLOW_UP_CHAT',
    icon: 'chat',
    actionKey: 'followUpChat',
    requiredSupportingCompanyAccessLevel: null,
  },
  {
    supportedTypes: [ROLES_KEYS.Foreigner],
    labelKey: 'MANAGEMENT.FOLLOW_UP.FOLLOW_UP_EMAIL',
    icon: 'mail',
    actionKey: 'followUpEmail',
    requiredSupportingCompanyAccessLevel: null,
  },
  {
    supportedTypes: [ROLES_KEYS.Foreigner, ROLES_KEYS.Employer],
    labelKey: 'MANAGEMENT.CHAT.GET_TRANSCRIPTION',
    icon: 'download',
    actionKey: 'getTranscription',
    requiredSupportingCompanyAccessLevel: null,
  },
  {
    supportedTypes: [ROLES_KEYS.Foreigner],
    labelKey: 'COMMON.REDIRECT.GO_TO_FOREIGNER_DETAILS',
    icon: 'person',
    actionKey: 'none',
    routerLink: ['/management/foreigner-details'],
    queryParams: { tabIndex: 0 },
    permissionKey: 'CAN_EDIT_FOREIGNER',
    requiredSupportingCompanyAccessLevel: SupportingCompanyAccessLevel.canEditProcesses,
  },
];
